<app-header></app-header>
<app-welcome-banner></app-welcome-banner>
<app-how-i-choose></app-how-i-choose>
<app-find-your-midwife></app-find-your-midwife>
<app-blogs></app-blogs>
<app-footer></app-footer>
